/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Text, Spacer, FlexContainer, theme } from "@nordcloud/gnui";
import { DetailsTitle } from "~/views/environments/components/DetailsTitle";

type Props = {
  name: string;
  owner: string;
  contact: string;
  description: string;
};

export function ReadonlyDetails({ name, owner, contact, description }: Props) {
  return (
    <div>
      <Text isTitle weight="medium">
        Application Details
      </Text>
      <FlexContainer alignItems="center">
        <DetailsTitle>Application Name:</DetailsTitle>
        <Text as="div" m="0">
          {name}
        </Text>
      </FlexContainer>
      <Spacer height={theme.spacing.spacing02} />
      <FlexContainer alignItems="center">
        <DetailsTitle>Application Owner:</DetailsTitle>
        <Text as="div" m="0">
          {owner}
        </Text>
      </FlexContainer>
      <Spacer height={theme.spacing.spacing02} />
      <FlexContainer alignItems="center">
        <DetailsTitle>Contact Person:</DetailsTitle>
        <Text as="div" m="0">
          {contact}
        </Text>
      </FlexContainer>
      <Spacer height={theme.spacing.spacing02} />
      <FlexContainer alignItems="center">
        <DetailsTitle>Description:</DetailsTitle>
        <Text as="div" m="0">
          {description}
        </Text>
      </FlexContainer>
    </div>
  );
}
